import {
  getFactsRecursively,
  getAllFactsFromAdvancedSearch,
  getCriteriaFromAdvancedSearch,
  getDataFormCriteriaFromAdvancedSearch,
  getResultsByType,
  getSizeOrZero,
  getTotalResults,
  getFacetGroups,
  setFacetNameAndValues,
  setFacets,
  getFacets,
  setTreeNodeTrackingSearchType,
  generateTrackedObjFromNodesList,
} from './CatalystHelper';

export default {
  getFactsRecursively,
  getAllFactsFromAdvancedSearch,
  getCriteriaFromAdvancedSearch,
  getDataFormCriteriaFromAdvancedSearch,
  getResultsByType,
  getSizeOrZero,
  getTotalResults,
  getFacetGroups,
  setFacetNameAndValues,
  setFacets,
  getFacets,
  setTreeNodeTrackingSearchType,
  generateTrackedObjFromNodesList,
};
